"use client";
import { useController, useForm } from "react-hook-form";
import { Button, FormGroup } from "cy-fe";
import {
  getCheckboxProps,
  StyledCheckbox,
  StyledCheckboxContainer,
  StyledCheckboxLabel,
} from "cy-fe/src/components/Forms/Checkboxes";
import * as StepWizard from "cy-ui/components/StepWizard";
import { BodyContainer } from "cy-remittance/components/layouts";
import { ChangePassword, ChangePasswordFormInputs } from "./ChangePassword";
import { NextLink } from "cy-fe";
import { HeaderText } from "cy-remittance/components/HeaderText";

export function PasswordPage({
  onSubmit,
  backUrl,
  termsAndConditionsUrl,
  termsAgreementPrefix = "I agree to the",
}: {
  onSubmit: (args: { password: string }) => void;
  backUrl: string;
  termsAndConditionsUrl: string;
  termsAgreementPrefix?: string;
}) {
  const form = useForm<ChangePasswordFormInputs>();

  const consent = useController({
    control: form.control,
    name: "agree",
    rules: { required: true },
  });
  return (
    <StepWizard.StepPageLayout
      backUrl={backUrl}
      headerRender={() => <HeaderText vCenter>Create your account</HeaderText>}
      subHeaderRender={() => <>Choose a password to secure your account</>}
    >
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <BodyContainer className="mt-10">
          <ChangePassword form={form} />

          <FormGroup
            className="flex items-center"
            controller={{ control: form.control, name: "agree" }}
          >
            <StyledCheckboxContainer className="flex gap-3">
              <StyledCheckbox
                error={!!consent.fieldState.error}
                {...getCheckboxProps(consent)}
                className="mt-[0.3rem] flex-shrink-0"
              />
              <StyledCheckboxLabel className="text-base font-normal">
                {termsAgreementPrefix}&nbsp;
                <NextLink
                  href={termsAndConditionsUrl}
                  target="_blank"
                  className="font-bold underline underline-offset-2"
                >
                  terms and conditions.
                </NextLink>
              </StyledCheckboxLabel>
            </StyledCheckboxContainer>
          </FormGroup>

          <Button
            loading={form.formState.isSubmitting}
            vSize="lg"
            className="w-full"
          >
            Submit
          </Button>
        </BodyContainer>
      </form>
    </StepWizard.StepPageLayout>
  );
}
